<template>
  <v-form @submit.prevent="save">
    <v-container>
        <v-layout wrap>
            <v-flex xs12 sm6 md4 v-if="!edit">
                <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="collectiveVacation.start"
                        persistent
                        lazy
                        full-width
                        width="290px"
                >
                    <v-text-field
                            slot="activator"
                            v-model="computedStart"
                            :label="$t('Pages.Vacations.model.start')"
                            prepend-icon="event"
                            readonly
                            color="indigo"
                            v-validate="'required'"
                            :error-messages="errors.first('start')"
                            name="start"
                            required
                    ></v-text-field>
                    <v-date-picker locale="sr-Latn-RS" :allowed-dates="allowedDates" first-day-of-week="1" :events="functionEvents" color="indigo" v-model="collectiveVacation.start" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat @click="modal = false">{{$t('Core.Fields.cancel')}}</v-btn>
                        <v-btn flat color="indigo" @click="$refs.dialog.save(collectiveVacation.start)">{{$t('Core.Fields.ok')}}</v-btn>
                    </v-date-picker>
                </v-dialog>
            </v-flex>
            <v-flex xs12 sm6 md4 v-if="!edit">
                <v-dialog
                        ref="dialogEnd"
                        v-model="modalEnd"
                        :return-value.sync="collectiveVacation.end"
                        persistent
                        lazy
                        full-width
                        width="290px"
                >
                    <v-text-field
                            slot="activator"
                            v-model="computedEnd"
                            :label="$t('Pages.Vacations.model.end')"
                            prepend-icon="event"
                            readonly
                            color="indigo"
                            v-validate="'required'"
                            :error-messages="errors.first('end')"
                            name="end"
                            required
                    ></v-text-field>
                    <v-date-picker locale="sr-Latn-RS" :allowed-dates="allowedDates" :min="collectiveVacation.start" first-day-of-week="1" :events="functionEvents" color="indigo" v-model="collectiveVacation.end" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat @click="modalEnd = false">{{$t('Core.Fields.cancel')}}</v-btn>
                        <v-btn flat color="indigo" @click="$refs.dialogEnd.save(collectiveVacation.end)">{{$t('Core.Fields.ok')}}</v-btn>
                    </v-date-picker>
                </v-dialog>
            </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-btn round color="indigo" dark type="submit">
          {{$t('Core.Fields.save')}}
        </v-btn>
        <v-btn round href="javascript:history.go(-1)">
          {{$t('Core.Fields.back')}}
        </v-btn>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
    import Form from '../../services/Form'
    import _ from 'lodash';
export default {
  components: {},
  props: {
      collectiveVacation: {
          type: Object,
          required: true
      },
      edit: {
          type: Boolean,
          default: false
      }
  },
  data: () => ({
    modal: false,
    modalEnd: false,
    message: '',
  }),
  computed: {
      computedStart(val){
          return this.getLocaleDateFormat(this.collectiveVacation.start);
      },
      computedEnd(val){
          return this.getLocaleDateFormat(this.collectiveVacation.end);
      },
  },
  created () {
        this.getHolidays();
        this.getCollectiveVacations();
  },
  methods: {

      save(){
        this.$validator.validateAll().then((result) => {
            if (result) {
              let data = JSON.parse(JSON.stringify(this.collectiveVacation));
              this.$emit('save', data);
            }
        });
      },
      allowedDates(val){
          if(_.find(this.holidays, ['date', val])){
              return false;
          }

          //potrebno im je da im se kolektivni odmori preklapaju
/*          if(this.isCollectiveVacationDate(val)){
              return false;
          }*/

          let date = new Date(Date.parse(val));

          return date.getDay()%6 !=0 ;
      }
  }
}
</script>

<style lang="scss">

</style>
